<template>
  <el-dialog
    title="出库记录"
    :visible.sync="visible"
    width="850px"
    @close="$emit('update:show', false)"
  >
    <el-table :data="logs" v-loading="loading">
      <el-table-column label="出库单号" prop="code_number" width="180"></el-table-column>
      <el-table-column label="申请人" prop="applicant" align="center"></el-table-column>
      <el-table-column label="出库单价" align="center">
        <template slot-scope="scope">{{scope.row.price.toFixed(2)}}</template>
      </el-table-column>
      <el-table-column label="出库数量" prop="number" align="center"></el-table-column>
      <el-table-column label="出库日期" prop="date" width="150" align="center"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { storeItemOutLogList } from '@/service/getData'
import { Loading } from 'element-ui'

export default {
  props: {
    model: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show() {
      this.visible = this.show
    },
    'model.id': 'getData'
  },
  data() {
    return {
      visible: this.show,
      loading: true,
      logs: []
    }
  },
  methods: {
    async getData() {
      this.loading = true
      if (this.model.id > 0) {
        let res = await storeItemOutLogList(this.model.id)
        this.logs = res.data.logs.map(item => {
          let newItem = {
            code_number: item.stock_out_bill.code_number,
            applicant: item.stock_out_bill.applicant.name,
            price: item.item_price,
            number: item.item_number,
            date: item.stock_out_bill.stock_out_date
              ? this.$time(item.stock_out_bill.stock_out_date).format(
                  'YYYY-MM-DD'
                )
              : ''
          }
          return newItem
        })
        this.loading = false
      } else {
        this.loading = false
      }
    }
  }
}
</script>